import React from 'react';
import PropTypes from 'prop-types';
import { AspectRatioCardImage } from '@homeaway/react-aspect-ratio-card';
import { SHORT_CAROUSEL_ASPECT_RATIO, TALL_CAROUSEL_ASPECT_RATIO } from '../constants';

const LazyLoadAspectRatioCardImage = ({ imageUri, aspectRatio, loadImage = false }) => {
  return imageUri && loadImage ? (
    <AspectRatioCardImage
      imageUri={imageUri}
      aspectRatio={aspectRatio}
    />
  ) : null;
};

LazyLoadAspectRatioCardImage.propTypes = {
  imageUri: PropTypes.string.isRequired,
  loadImage: PropTypes.bool.isRequired,
  aspectRatio: PropTypes.oneOf([TALL_CAROUSEL_ASPECT_RATIO, SHORT_CAROUSEL_ASPECT_RATIO])
};

export default LazyLoadAspectRatioCardImage;